// extracted by mini-css-extract-plugin
export default {"root":"search_root__KI8bc","input":"search_input__OU007","button":"search_button__744v8"};